import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Dialog, Form, InputNumber, Select, Switch } from 'tdesign-react';
import styled from 'styled-components';
import { fetchProPolices } from '@/slices/namespaceSlice';
import { UNSAFE_bugSetFieldsValue, deal70101, isEmpty, toTsOptions } from '@/utils/common';
import { updateAutoswitchPolicy } from '@/services/namespaceService';
import useDisableButton from '@/components/DisableWrapper/useDisableButton';

const { FormItem } = Form;

function Modal({ visible, handleClose, detail, commonProps, fetchProPolices }) {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);
  const allowAutoTopicCreation = Form.useWatch('allowAutoTopicCreation', form);
  const autoTopicCreationType = Form.useWatch('autoTopicCreationType', form);

  const confirmBtn = useDisableButton({ loading: submitting, content: '确定' });

  useEffect(() => {
    if (visible) {
      form.reset();
      UNSAFE_bugSetFieldsValue(form, detail);
    }
  }, [form, visible, detail]);

  const onCancel = () => {
    handleClose();
  };

  const handleSubmit = async ({ validateResult, fields }) => {
    if (validateResult === true) {
      setSubmitting(true);
      try {
        const { meta } = await updateAutoswitchPolicy({
          ...commonProps,
          ...fields,
        });
        // 主集群创建的资源已在灾备集群存在
        if (meta.code === 70101) {
          deal70101(meta.publicMessage, () => handleSubmit({ validateResult, fields }), {
            url: '/cluster/namespace/list',
            namespace: commonProps.namespace,
          });

          return;
        }
        await fetchProPolices(commonProps);
        handleClose();
      } catch (error) {
        console.trace(error);
        throw error;
      } finally {
        setSubmitting(false);
      }
    }
  };

  return (
    <Root
      onConfirm={() => form.submit()}
      confirmBtn={confirmBtn}
      visible={visible}
      header='自动策略'
      width={550}
      onClose={onCancel}
    >
      <Form
        form={form}
        resetType='initial'
        onSubmit={handleSubmit}
        style={{ width: '80%' }}
        labelWidth={140}
      >
        <FormItem name='allowAutoTopicCreation' label='Topic'>
          <Switch label={['自动', '手动']} />
        </FormItem>
        {allowAutoTopicCreation && (
          <FormItem label='类型' rules={[{ required: true }]} name='autoTopicCreationType'>
            <Select
              clearable
              options={toTsOptions([
                { value: 'partitioned', label: 'partitioned' },
                { value: 'non-partitioned', label: 'non-partitioned' },
              ])}
            />
          </FormItem>
        )}
        {allowAutoTopicCreation && autoTopicCreationType === 'partitioned' && (
          <FormItem
            label='分区个数'
            rules={[
              { required: true },
              { validator: (val) => isEmpty(val) || val > 0, message: '请输入大于0的值' },
            ]}
            name='defaultNumPartitions'
          >
            <InputNumber theme='normal' decimalPlaces={0} />
          </FormItem>
        )}

        <FormItem name='allowAutoSubscriptionCreation' label='订阅者'>
          <Switch label={['自动', '手动']} />
        </FormItem>

        <FormItem name='isAllowAutoUpdateSchema' label='Schema'>
          <Switch label={['自动', '手动']} />
        </FormItem>
      </Form>
    </Root>
  );
}

export default connect(null, {
  fetchProPolices,
})(Modal);

const Root = styled(Dialog)`
  .t-input-number {
    width: auto;
    flex: 1;
  }
  .t-input__suffix {
    color: var(--td-font-gray-2);
  }
`;
